import { QueryClient } from '@tanstack/react-query';
import { errorUtils } from './errorUtils';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache data for 5 minutes by default
      staleTime: 5 * 60 * 1000,
      // Keep unused data in cache for 10 minutes
      gcTime: 10 * 60 * 1000,
      // Retry failed requests 3 times
      retry: (failureCount, error) => {
        if (failureCount >= 3) return false;
        return errorUtils.isRetryableError(error);
      },
      // Retry delay with exponential backoff
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      // Offline-first: never refetch in the background. Data is refreshed
      // only during a manual sync (see useOfflineSync.syncNow).
      refetchOnWindowFocus: false,
      // Don't refetch on reconnect — sync is manual, triggered by the user.
      refetchOnReconnect: false,
      // Handle query errors gracefully
      throwOnError: false,
      // Network mode for offline support
      networkMode: 'offlineFirst',
    },
    mutations: {
      // Retry mutations once on failure
      retry: (failureCount, error) => {
        if (failureCount >= 1) return false;
        return errorUtils.isRetryableError(error);
      },
      // Retry delay for mutations
      retryDelay: 1000,
      // Handle mutation errors gracefully
      throwOnError: false,
      // Network mode for offline support
      networkMode: 'offlineFirst',
    },
  },
});
